exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".history-detail[data-v-0d51c32f] {\n  margin-top: 15px;\n}\n.dayoff-item[data-v-0d51c32f] {\n  border: 0px;\n}", ""]);

// exports
